export default function authHeader() {
  const token = sessionStorage.getItem("token");
  const roleName = sessionStorage.getItem("roleName");

  if (token && roleName) {
    return { Authorization: `Bearer ${token}` };
  } else {
    return {};
  }
}
